import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-event-dialog',
  templateUrl: './modal-event-dialog.component.html',
  styleUrls: ['./modal-event-dialog.component.css']
})
export class ModalEventDialogComponent implements OnInit
{

  constructor(@Inject(MAT_DIALOG_DATA) public data: string[]) { }

  ngOnInit()
  {
  }

}
